module.exports = __webpack_public_path__ + "img/mail.8e4e5bc9.svg";